<template>
  <div class="modal-card">
    <CloseIcon :size="24" class="close-modal-icon close-on-click" />
    <div class="modal-card-header">
      <h1 class="title">Monitor Date</h1>
      <p class="subtitle">Set the next monitoring date for {{ patientName }}.</p>
    </div>

    <div class="modal-card-body">
      <div class="field">
        <label class="form-label">Next monitor date</label>
        <DateInput v-model="monitorDate" placeholder="MM/DD/YYYY" />
      </div>
    </div>

    <div class="modal-card-footer">
      <button v-if="patient.monitorDate" class="button form-button" :disabled="isSaving" @click="handleClear">
        Clear
      </button>
      <button class="button primary form-button" :disabled="!canSubmit" @click="handleSubmit">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import DateInput from '@/components/inputs/DateInput.vue';
import * as api from '@/api';
import { queryClient } from '@/libs/queryClient';
import { alertService } from '@/libs/alert';

export default {
  name: 'SetMonitorDateModal',
  components: { CloseIcon, DateInput },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  emits: ['saved'],
  data() {
    return {
      monitorDate: this.patient.monitorDate || '',
      isSaving: false
    };
  },
  computed: {
    patientName() {
      return `${this.patient.firstName || ''} ${this.patient.lastName || ''}`.trim() || 'this patient';
    },
    canSubmit() {
      return !!this.monitorDate && !this.isSaving;
    }
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return;
      this.save(this.monitorDate);
    },
    handleClear() {
      this.save(null);
    },
    async save(monitorDate) {
      this.isSaving = true;
      try {
        await api.setTrtMonitorDate(this.patient.patientId, monitorDate);
        queryClient.invalidateQueries({ queryKey: ['trt-cards'] });
        this.$emit('saved');
      } catch (err) {
        console.error('Failed to set monitor date:', err);
        alertService.error('Failed to set monitor date: ' + err.message);
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-top: 8px;
}

.modal-card-body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.modal-card-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
